
import { useToast } from "@/components/ui/use-toast";

export const useCSVExporter = () => {
  const { toast } = useToast();

  const exportToCSV = async (exportData: Record<string, string>[], filename: string) => {
    try {
      const Papa = await import('papaparse');
      const csv = Papa.unparse(exportData, {
        quotes: true,
        newline: '\r\n'
      });

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast({
        title: "Success",
        description: "Aggregated file exported successfully as CSV",
      });
    } catch (error) {
      console.error('CSV export error:', error);
      toast({
        title: "Error",
        description: "Failed to export CSV file",
        variant: "destructive",
      });
    }
  };

  return { exportToCSV };
};
